import { ItemStockAmount, StockLocationInfo } from '../types/item-stock-amount';

export interface OwnStockAmount extends ItemStockAmount {
  own: StockLocationInfo | null;
}

/** A stock location's `stock.name` is the number its VKFORG code starts with ("010" ↔ "010-Pregarten"). */
export function ownStockFirst(
  stock: ItemStockAmount,
  salesOrganisationCode: string | null | undefined
): OwnStockAmount {
  const locations = stock.stockAmount ?? [];
  const number = salesOrganisationCode?.split('-')[0].trim();
  const own = number
    ? (locations.find((o) => o.stock?.name?.trim() === number) ?? null)
    : null;
  return {
    ...stock,
    own,
    stockAmount: own ? [own, ...locations.filter((o) => o !== own)] : locations,
  };
}
